import {MailOrdersListToolbar} from './MailOrderListToolbar'
import {MailOrdersListSearchComponent} from './MailOrdersListSearchComponent'

const MailOrdersListHeader = () => {
  return (
    <div className='card-header border-0 pt-6 pb-4 flex-wrap gap-3'>
      <MailOrdersListSearchComponent />
      <div className='card-toolbar ms-auto'>
        <MailOrdersListToolbar />
      </div>
    </div>
  )
}

export {MailOrdersListHeader}
